import { render, staticRenderFns } from "./ModalOutorgado.vue?vue&type=template&id=ef668506"
import script from "./ModalOutorgado.vue?vue&type=script&lang=js"
export * from "./ModalOutorgado.vue?vue&type=script&lang=js"
import style0 from "./ModalOutorgado.vue?vue&type=style&index=0&id=ef668506&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports